import * as React from "react";
import tmpReact from "@Tmp/Helpers";
import Transition from "./Transition";
import Fade from "./Fade";

function Dropdown(props) {
    const clickOutsideRef = React.useRef(null);

    const onClose = () => {
        if (props.onClose) {
            props.onClose();
        }
    };

    const timeout = props.timeout ? props.timeout : 300;

    React.useEffect(() => {
        const handleClickOutside = (e) => {
            if (clickOutsideRef.current && !clickOutsideRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [clickOutsideRef]);

    return (
        <>
            {props.backdrop ? (
                <Fade in={props.open} timeout={timeout}>
                    <div
                        className={tmpReact.printClasses(props.classes?.backdrop, [
                            "tmp-dropdown-backdrop",
                        ])}
                    ></div>
                </Fade>
            ) : null}
            <Transition
                type={props.animation}
                in={props.open}
                direction={props.direction}
                timeout={timeout}
                onExit={props.onExit}
                onEnter={props.onEnter}
            >
                <div
                    ref={clickOutsideRef}
                    className={tmpReact.printClasses(props.classes?.container, [
                        "tmp-dropdown-container",
                    ])}
                >
                    <div className="tmp-dropdown">
                        <div className="tmp-dropdown-close" onClick={onClose}>
                            <i className="fas fa-times fa-2x"></i>
                        </div>
                        <div className="tmp-dropdown-content">{props.children}</div>
                    </div>
                </div>
            </Transition>
        </>
    );
}

export default Dropdown;
